/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateAssociatedCompanyDocumentStatusRequestViewModel } from "../types/UpdateAssociatedCompanyDocumentStatusRequestViewModel.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";

export const updateAssociatedCompanyDocumentStatusRequestViewModelSchema =
  z.object({
    personId: z.optional(
      z.number().int().describe("ID da pessoa (aluno) dona dos anexos."),
    ),
    status: z.optional(
      z
        .lazy(() => eDocumentationStatusSchema)
        .describe(
          "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
        ),
    ),
    observationId: z
      .number()
      .int()
      .describe(
        "ID do motivo de rejeição (DocumentRejectionReason); obrigatório quando Status = Rejeitado. Opcional.",
      )
      .nullish(),
  }) as unknown as ToZod<UpdateAssociatedCompanyDocumentStatusRequestViewModel>;
